// Simple global event bus without DOM/EventTarget dependencies
const listeners = new Map(); // type -> Set<fn>

export const emit = (type, detail) => {
  const fns = listeners.get(type);
  if (!fns) return;
  // Clone to avoid mutation during iteration
  [...fns].forEach((fn) => {
    try { fn(detail); } catch (_) { /* noop */ }
  });
};

export const on = (type, listener) => {
  if (!listeners.has(type)) listeners.set(type, new Set());
  const set = listeners.get(type);
  set.add(listener);
  return () => {
    set.delete(listener);
    if (set.size === 0) listeners.delete(type);
  };
};

export const EVENTS = {
  INVENTORY_REFRESH: 'inventory:refresh',
  ORDER_PLACED: 'order:placed',
  CART_CHANGED: 'cart:changed',
  ENTITLEMENT_DENIED: 'entitlement:denied',
  ENTITLEMENTS_REFRESH: 'entitlements:refresh',
  // Help system (step 9) telemetry — design_handoff_help_system/README.md.
  HELP_TOPIC_OPEN: 'help.topic_open',
  HELP_SEARCH_ZERO_RESULTS: 'help.search_zero_results',
  HELP_FEEDBACK: 'help.feedback',
  HELP_TOUR_STEP: 'help.tour_step',
  HELP_SUPPORT_SENT: 'help.support_sent',
};

const eventBus = { emit, on, EVENTS };
export default eventBus;
